import { SafeDictionary } from "@insite/client-framework/Common/Types";
import {
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidatePostalCode } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import {
    AddressFieldDisplayCollectionModel,
    AddressFieldDisplayModel,
    BaseAddressModel,
    CustomerValidationDto,
} from "@insite/client-framework/Types/ApiModels";

export type AddressErrors = SafeDictionary<React.ReactNode>;

type HandlerType = Handler<
    {
        address: BaseAddressModel;
        validationRules: CustomerValidationDto;
        addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
    } & HasOnSuccess<AddressErrors>,
    {
        addressErrors: AddressErrors;
    }
>;

const isEmpty = (value: string) => value.trim().length <= 0;

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

const ValidatePostalCodeExtended: HandlerType = props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { postalCode } = props.parameter.address;
    if (
        addressFieldDisplayCollection.postalCode?.isVisible &&
        validationRules.postalCode?.isRequired &&
        isEmpty(postalCode)
    ) {
        props.addressErrors.postalCode = getRequiredErrorMessage(addressFieldDisplayCollection.postalCode);
    } else if (!isEmpty(postalCode) && postalCode.length < 6) {
        props.addressErrors.postalCode = siteMessage("Postal_Code_Character_Limit_Error");
    }
};

replaceInChain(chain, ValidatePostalCode, ValidatePostalCodeExtended);
